import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingBanker } from 'services/setting'
import posthog from 'posthog-js'

/**
 * `previous` is what the server had when the page loaded; only the switches
 * that actually moved are reported as `banker_permission_toggled`.
 */
export default function useSetBankerAccess(
    refetch: () => void,
    previous: IBankerSetting | undefined
) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingBankerPayload) => settingBanker(payload),
        onSuccess: (_data, variables) => {
            const { moneyPool, ...next } = variables
            ;(Object.keys(next) as Array<keyof IBankerSetting>).forEach(
                (key) => {
                    if (previous && previous[key] === next[key]) return
                    posthog.capture('banker_permission_toggled', {
                        fund_id: moneyPool,
                        key,
                        enabled: next[key],
                    })
                }
            )
            refetch()
            toast.success('تغییرات با موفقیت انجام شد')
        },
        onError: (error: any, variables) => {
            posthog.capture('fund_setting_save_failed', {
                section: 'banker',
                fund_id: variables?.moneyPool,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate, isLoading }
}
